import { gql } from '@apollo/client';

export const TAGS_FOR_TYPE = gql`
  query tagsForType($type: String!, $filter: TagsFilter) {
    tagsForType(type: $type, filter: $filter) {
      id
      name
      pid
      uuid
      root_tag_id
      rootTag {
        created
        key
        name
        updated
        uuid
      }
    }
  }
`;

export type TagForType = {
  id: string;
  name: string;
  pid: string;
  uuid: string;
  root_tag_id: string;
  rootTag: {
    created: string;
    key: string;
    name: string;
    updated: string;
    uuid: string;
  };
};

export type TagsForTypeQueryResult = {
  tagsForType: TagForType[];
};

export type TagsForTypeQueryVariables = {
  type: string;
  filter?: any;
};
